const firebaseConfig = {
  apiKey: "AIzaSyAsiZXE5miHFOjjkHv7Wp1vel82xJ9I3DE",
  authDomain: "amacoin-de762.firebaseapp.com",
  databaseURL: "amacoin-de762.firebaseapp.com",
  projectId: "amacoin-de762",
  storageBucket: "amacoin-de762.appspot.com",
  messagingSenderId: "742582593408",
  appId: "1:742582593408:web:95c27aeb7380ea45710365",
  measurementId: "G-ZN6P3TRHNZ",
  cloudMessagingServerKey:
    "AAAArOVfJ4A:APA91bFzt4FoEUdMot-Bw52tLoTVngKH3heRo8ROLkaV1-gK_M9ZcB0Vle-k0cEPg5fDBvMI-SLx46a_KedAl3QAlS6bhwruyPFl2uA4YpuVsSyN4qsNRV7NtI75pYk91cvd5gIFUueP",
};

export default firebaseConfig;
